
$(document).ready(function(){
	
	
	$('.card-slider-fwd').click(function(){

		$('.slider-scroll-content').animate({'left':'-=300px'});

	});

	$('.card-slider-back').click(function(){

		$('.slider-scroll-content').animate({'left':'+=300px'});

	});
	// $('.card-slider-fwd').click(function() {
	// 	console.log('yo');
	// 	var far = $( '.slider-scroll-content' ).width();
	// 	var pos = $('.slider-scroll-content').scrollLeft() + far;
	// 	$('.slider-scroll-content').animate( { scrollLeft: pos }, 1000);
	// });
	
	// $('.card-slider-back').click(function() {
	// 	console.log('yo');
	// 	var far = $( '.slider-scroll-content' ).width();
	// 	var pos = $('.slider-scroll-content').scrollLeft() + far;
	// 	$('.slider-scroll-content').animate( { scrollLeft: pos }, 1000);
	// });
});